import {Grid, Typography} from "@material-ui/core";
import React from "react";

const CustomHeader = (props: any) => {

    let title = props.title || '';
    // const theme = useTheme();

    return <Grid item xs={12}>
        <Grid container spacing={0}>

            <Grid item xs={12} sm={8} style={({textAlign: 'center'})}>
                <Typography variant="h3" color={"textSecondary"} display={"block"} component="div">
                    <br/>
                    <strong>{title}</strong>
                </Typography>
            </Grid>
        </Grid>
    </Grid>

}

export default CustomHeader;
